module.exports = __webpack_public_path__ + "img/big_1_81.676ed82b.png";